<template>
  <form>
    <div class="card card-info" runat="server">
      <div class="card-header with-border">
        <h3 class="card-title">Department Coordinator</h3>
      </div>
      <!-- /.box-header -->
      <!-- form start -->
      <div class="card-body">
        <div class="row">
              <div class="col-md-6">
                <label>Session</label>
                <select class="form-control" v-model="ActiveSemesterID" required v-on:change="sessChange()">
                  <option value="0" disabled>--Select Session--</option>
                  <option v-for="item in session" v-bind:value="item.SemesterID">{{item.Name}}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label>Instructor</label>
                <v-select v-model="Employee" v-bind:multiple="false" v-bind:options="employee" label="Name" style="max-width: 100%;"></v-select>
              </div>
        </div>
      </div>
        
      <hr />
      <!--Button -->
      <div class="card-footer">
        <button class="btn btn-success float-right" style="width: 120px" type="button" v-on:click="loadRecord()">Load Record</button>
        <button class="btn btn-info float-right" v-show="grid === 'show'" style="width: 120px;margin-right: 10px;" type="button" v-on:click="Print()">Print</button>
        <button class="btn btn-danger" style="width: 120px" type="button" v-on:click="clear()">Cancel</button>
      </div>
    </div>
    <div class="card card-info" runat="server" v-show="grid === 'show'">
      <div class="card-header with-border">
        <h3 class="card-title">Instructor Work Load</h3>
        <!--<%--<button type="button" class="btn btn-primary" style="float: right" v-on:click="changestate()">+Add New</button>--%>-->
      </div>
      <!-- /.box-header -->
      <!-- form start -->
      <div class=" form-horizontal">
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table" v-for="campus in record">
                <thead>
                  <tr>
                    <th class="text-center">
                      <h4 style="width: 100%">{{campus.EmpCode}} - {{campus.Name}} - {{campus.Designation}}</h4>
                    </th>
                  </tr>
                </thead>
                <tr>
                  <td>
                    <table style="width: 100%;" class="table table-sm table-bordered">
                      <thead class="bg-info">
                        <tr >
                          <th rowspan="2" style="text-align: center" width="10%">Course Code</th>
                          <th rowspan="2" style="text-align: center" width="30%">Course Name</th>
                          <th rowspan="2" style="text-align: center" width="30%">Program</th>
                          <th rowspan="2" style="text-align: center" width="15%">No Of Students</th>
                          <th colspan="3" style="text-align: center" width="15%">Credit Hours</th>
                        </tr>
                        <tr style="border-top: 1px solid black; color: white">
                          <th style="text-align: center" width="5%">Th</th>
                          <th style="text-align: center" width="5%">Lb</th>
                          <th style="text-align: center" width="5%">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="inq in campus.Courses">
                          <td>{{inq.Code}}</td>
                          <td>{{inq.CourseName}}</td>
                          <td>{{inq.ProgramName}}</td>
                          <td style="text-align: center">{{inq.NoOfStudents}}</td>
                          <td style="text-align: center">{{inq.Theory}}</td>
                          <td style="text-align: center">{{inq.Lab}}</td>
                          <td style="text-align: center">{{inq.CreditHours}}</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr style="text-align: center; font-weight: bolder">
                          <td colspan="4">
                            Total Credit Hours
                          </td>
                          <td>
                            {{campus.ThTotal}}
                          </td>
                          <td>
                            {{campus.LbTotal}}
                          </td>
                          <td>
                            {{campus.ThTotal + campus.LbTotal}}
                          </td>
                        </tr>
                      </tfoot>
                      
                    </table>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-sm" v-for="campus in visrecord">
                <thead>
                  <tr>
                    <th class="text-center">
                      <h4 style="width: 100%">{{campus.EmpCode}} - {{campus.Name}} - {{campus.Designation}}</h4>
                    </th>
                  </tr>
                </thead>
                <tr>
                  <td>
                    <table style="width: 100%;" class="table table-sm table-bordered">
                      <thead class="bg-info">
                        <tr>
                          <th rowspan="2" style="text-align: center" width="10%">Course Code</th>
                          <th rowspan="2" style="text-align: center" width="30%">Course Name</th>
                          <th rowspan="2" style="text-align: center" width="30%">Program</th>
                          <th rowspan="2" style="text-align: center" width="15%">No Of Students</th>
                          <th colspan="3" style="text-align: center" width="15%">Credit Hours</th>
                        </tr>
                        <tr style="border-top: 1px solid black;">
                          <th style="text-align: center" width="5%">Th</th>
                          <th style="text-align: center" width="5%">Lb</th>
                          <th style="text-align: center" width="5%">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="inq in campus.Courses">
                          <td>{{inq.Code}}</td>
                          <td>{{inq.CourseName}}</td>
                          <td>{{inq.ProgramName}}</td>
                          <td style="text-align: center">{{inq.NoOfStudents}}</td>
                          <td style="text-align: center">{{inq.Theory}}</td>
                          <td style="text-align: center">{{inq.Lab}}</td>
                          <td style="text-align: center">{{inq.CreditHours}}</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr style="text-align: center; font-weight: bolder">
                          <td colspan="4">
                            Total Credit Hours
                          </td>
                          <td>
                            {{campus.ThTotal}}
                          </td>
                          <td>
                            {{campus.LbTotal}}
                          </td>
                          <td>
                            {{campus.ThTotal + campus.LbTotal}}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        ActiveSemesterID: 0,
        employee: [],
        session: [],
        record: [],
        visrecord: [],
        grid: 'hide',
        Employee: null,
      }
    },
    created: function () {
      this.pageload();
    },

    updated: function () {
      $('#bs4').DataTable();
    },
    methods:
    {
      changestate() {
        this.showgrid = 'false';
      },

      pageload() {
        var vm = this;
        axios.post('/api/DCApi/loadActiveSemester')
          .then(function (response) {
            vm.session = response.data.lst;
          })
      },

      sessChange() {
        var vm = this;
        vm.Employee = null,
          axios.post('/api/DCApi/loadInstructor?semID=' + vm.ActiveSemesterID)
          .then(function (response) {
            vm.employee = response.data.lst;
            })
      },

      loadRecord() {
        startReq();
        var vm = this;
        axios.post('/api/DCApi/loadInstructorRecord?sessID=' + vm.ActiveSemesterID + '&EmpID=' + vm.Employee.EmployeeRegistrationID) //, { EmpID: vm.Employee == null ? 0 : vm.Employee.EmployeeRegistrationID}
          .then(function (response) {
            $('#bs4').DataTable().destroy();
            vm.record = response.data.empWise;
            vm.visrecord = response.data.empWisevis;
            vm.grid = 'show';
            endReq();
          })
      },

      clear() {
        window.location.reload();
      },

      Print() {
        var vm = this;
        axios.post('/api/DCApi/loadInstructorRecord?sessID=' + vm.ActiveSemesterID + '&EmpID=' + vm.Employee.EmployeeRegistrationID)
          .then(function (res) {

            window.open("/DC/InstructorWorkLoadPrint?sessID=" + vm.ActiveSemesterID + '&EmpID=' + vm.Employee.EmployeeRegistrationID, '_blank');

          })
      }
    },
  })
</script>
<style>
  h4 {
    padding-top: 6px;
    color: black;
    padding-bottom: 0px;
  }

  h6 {
    padding-top: 4px;
    color: black;
    margin-bottom: 4px;
  }

  strong {
    padding-top: 3px;
  }

  .table-grid {
    width: 100%;
    border-collapse: collapse;
  }

    .table-grid > tbody > tr > th {
      padding: 0;
    }

    .table-grid > thead > tr > th,
    .table-grid > tbody > tr > th,
    .table-grid > tfoot > tr > th,
    .table-grid > thead > tr > td,
    .table-grid > tbody > tr > td,
    .table-grid > tfoot > tr > td {
      border: 1px solid black;
    }

    .table-grid .table-grid td,
    .table-grid .table-grid th {
      border-top: 0;
      border-right: 1px solid black;
      border-bottom: 0;
      border-left: 0;
    }

      .table-grid .table-grid td:last-child,
      .table-grid .table-grid th:last-child {
        border-right: 0;
      }
</style>



// WEBPACK FOOTER //
// src/components/DC/instructorWorkLoad.vue